// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2NHsY","emails":"CreateEditClinics_emails__ioP8c","emailTagLabel":"CreateEditClinics_emailTagLabel__3qfvD"};